import { call, put, takeLatest } from 'redux-saga/effects';
import {
  changeInvoicePrice,
  createInvoice,
  createInvoiceComment,
  createInvoicePayment,
  createSubInvoices,
  deleteInvoice,
  excludeSubInvoices,
  getInvoiceDetail,
  getInvoiceList,
  mappingTaxInvoiceToInvoice,
  updateInvoice,
  updateInvoiceStatus,
} from '../../api/constlink';
import {
  deleteInvoiceAsync,
  DELETE_INVOICE,
  getInvoiceDetailAsync,
  getInvoiceListAsync,
  GET_INVOICE_DETAIL,
  GET_INVOICE_LIST,
  updateInvoiceAsync,
  UPDATE_INVOICE,
  createInvoiceAsync,
  CREATE_INVOICE,
  createInvoiceCommentAsync,
  CREATE_INVOICE_COMMENT,
  CREATE_SUB_INVOICE,
  createSubInvoiceAsync,
  EXCLUDE_SUB_INVOICE,
  excludeSubInvoiceAsync,
  updateInvoiceStatusAsync,
  UPDATE_INVOICE_STATUS,
  CREATE_INVOICE_PAYMENT,
  createInvoicePaymentAsync,
  changeInvoicePriceAsync,
  CHANGE_INVOICE_PRICE,
  mappingTaxInvoiceAsync,
  MAPPING_TAX_INVOICE,
} from './actions';
import { Invoice, InvoiceResponse } from './types';

function* getInvoiceListSaga(
  action: ReturnType<typeof getInvoiceListAsync.request>,
) {
  try {
    const response: InvoiceResponse = yield call(
      getInvoiceList,
      action.payload,
    );
    if (response.success === false)
      yield put(getInvoiceListAsync.failure(response.message));
    else yield put(getInvoiceListAsync.success(response.invoices!));
  } catch (e: any) {
    yield put(getInvoiceListAsync.failure(e.response?.data.message));
  }
}

function* updateInvoiceSaga(
  action: ReturnType<typeof updateInvoiceAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(updateInvoice, action.payload);
    yield put(updateInvoiceAsync.success(invoice));
  } catch (e: any) {
    yield put(updateInvoiceAsync.failure(e));
  }
}

function* deleteInvoiceSaga(
  action: ReturnType<typeof deleteInvoiceAsync.request>,
) {
  try {
    const response: InvoiceResponse = yield call(deleteInvoice, action.payload);
    if (response.success)
      yield put(deleteInvoiceAsync.success(response.invoiceId));
    else yield put(deleteInvoiceAsync.failure(response.message));
  } catch (e: any) {
    yield put(deleteInvoiceAsync.failure(e.response?.data.message));
  }
}

function* getInvoiceDetailSaga(
  action: ReturnType<typeof getInvoiceDetailAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(getInvoiceDetail, action.payload);
    yield put(getInvoiceDetailAsync.success(invoice));
  } catch (e: any) {
    yield put(getInvoiceDetailAsync.failure(e));
  }
}

function* createInvoiceSaga(
  action: ReturnType<typeof createInvoiceAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(createInvoice, action.payload);
    yield put(createInvoiceAsync.success(invoice));
  } catch (e: any) {
    yield put(createInvoiceAsync.failure(e));
  }
}

function* createInvoiceCommentSaga(
  action: ReturnType<typeof createInvoiceCommentAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(createInvoiceComment, action.payload);
    yield put(createInvoiceCommentAsync.success(invoice));
  } catch (e: any) {
    yield put(createInvoiceCommentAsync.failure(e));
  }
}

function* createInvoicePaymentSaga(
  action: ReturnType<typeof createInvoicePaymentAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(createInvoicePayment, action.payload);
    yield put(createInvoicePaymentAsync.success(invoice));
  } catch (e: any) {
    yield put(createInvoicePaymentAsync.failure(e));
  }
}

function* createSubInvoiceSaga(
  action: ReturnType<typeof createSubInvoiceAsync.request>,
) {
  try {
    const response: InvoiceResponse = yield call(
      createSubInvoices,
      action.payload,
    );
    if (response.success)
      yield put(createSubInvoiceAsync.success(response.invoices!));
    else yield put(createSubInvoiceAsync.failure(response.message));
  } catch (e: any) {
    yield put(createSubInvoiceAsync.failure(e.response?.data.message));
  }
}

function* excludeSubInvoiceSaga(
  action: ReturnType<typeof excludeSubInvoiceAsync.request>,
) {
  try {
    const response: InvoiceResponse = yield call(
      excludeSubInvoices,
      action.payload,
    );
    if (response.success)
      yield put(excludeSubInvoiceAsync.success(response.invoices!));
    else yield put(excludeSubInvoiceAsync.failure(response.message));
  } catch (e: any) {
    yield put(excludeSubInvoiceAsync.failure(e.response?.data.message));
  }
}

function* updateInvoiceStatusSaga(
  action: ReturnType<typeof updateInvoiceStatusAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(updateInvoiceStatus, action.payload);
    yield put(updateInvoiceStatusAsync.success(invoice));
  } catch (e: any) {
    yield put(updateInvoiceStatusAsync.failure(e));
  }
}

function* changeInoicePriceSaga(
  action: ReturnType<typeof changeInvoicePriceAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(changeInvoicePrice, action.payload);
    yield put(changeInvoicePriceAsync.success(invoice));
  } catch (e: any) {
    yield put(changeInvoicePriceAsync.failure(e));
  }
}

function* mappingTaxInvoiceSaga(
  action: ReturnType<typeof mappingTaxInvoiceAsync.request>,
) {
  try {
    const invoice: Invoice = yield call(
      mappingTaxInvoiceToInvoice,
      action.payload,
    );
    yield put(mappingTaxInvoiceAsync.success(invoice));
  } catch (e: any) {
    yield put(mappingTaxInvoiceAsync.failure(e));
  }
}

export function* invoicesSaga() {
  yield takeLatest(GET_INVOICE_LIST, getInvoiceListSaga);
  yield takeLatest(UPDATE_INVOICE, updateInvoiceSaga);
  yield takeLatest(DELETE_INVOICE, deleteInvoiceSaga);
  yield takeLatest(GET_INVOICE_DETAIL, getInvoiceDetailSaga);
  yield takeLatest(CREATE_INVOICE, createInvoiceSaga);
  yield takeLatest(CREATE_INVOICE_COMMENT, createInvoiceCommentSaga);
  yield takeLatest(CREATE_INVOICE_PAYMENT, createInvoicePaymentSaga);
  yield takeLatest(CREATE_SUB_INVOICE, createSubInvoiceSaga);
  yield takeLatest(EXCLUDE_SUB_INVOICE, excludeSubInvoiceSaga);
  yield takeLatest(UPDATE_INVOICE_STATUS, updateInvoiceStatusSaga);
  yield takeLatest(CHANGE_INVOICE_PRICE, changeInoicePriceSaga);
  yield takeLatest(MAPPING_TAX_INVOICE, mappingTaxInvoiceSaga);
}
